import {JSEncrypt} from "jsencrypt";
import {parseBigInt} from 'jsencrypt/lib/lib/jsbn/jsbn';
import {b64tohex} from 'jsencrypt/lib/lib/jsbn/base64';

export const appBaseUrl = window.location.origin + "/#/";
export const ddCorpId = "ding504e8d06a83af9e235c2f4657eb6378f";
import vm from "../main.js";

const pubKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCctQTweXAiaQ3ct5bhj6nyisOQiGmgC/hUdK+QO9I9DudcQSUMxIXvMtpiogB9RWkAUC4b86x7SiGD6aCp7PbTspd5fLf8F6LUIj/BtmktQq7JNsShjAWBxCkE49HIIvPvl9rt8lO7MkgS2vUT04tEYeu/62ltOc3BljJXoPC4pQIDAQAB";


export function listSort(dataList, key, order) {
  let flag = 1;
  if (order) {
    if (order.toLowerCase() === "desc") {
      flag = flag * -1;
    }
  }
  if (!dataList) {
    return dataList;
  }
  return dataList.sort((a, b) => {
    if (a[key] > b[key]) {
      return 1 * flag;
    } else if (a[key] < b[key]) {
      return -1 * flag;
    } else {
      return 0;
    }
  });
}

//js浮点数相除问题
export function div(a, b) {
  let c,
    d,
    e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) {
  }
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) {
  }
  return (
    (c = Number(a.toString().replace(".", ""))),
      (d = Number(b.toString().replace(".", ""))),
      accMul(c / d, Math.pow(10, f - e))
  );
}

//js中浮点数相乘问题
export function accMul(arg1, arg2) {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length;
  } catch (e) {
  }
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}

//小数格式化
export function formatDecimal(num, decimal) {
  num = num.toString();
  let index = num.indexOf(".");
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1);
  } else {
    num = num.substring(0);
  }
  return parseFloat(num).toFixed(decimal);
}

export function openMap(str) {
  // window.location.href = `http://api.map.baidu.com/geocoder?address=${str}&output=html&src=webapp.baidu.openAPIdemo`;
  let add = str;
  let lat = 0;
  let lng = 0;
  if (add) {
    AMap.plugin("AMap.Geocoder", () => {
      let geocoder = new AMap.Geocoder();
      geocoder.getLocation(add, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          console.log(result);
          if (result && result.geocodes[0] && result.geocodes[0].location) {
            lat = result.geocodes[0].location.lat;
            lng = result.geocodes[0].location.lng;
            let url = window.location.href.split("#")[0];
            vm.$get(`/api/wechat/getJsSdkVar?url=${url}`).then(res => {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature, // 必填，签名
                jsApiList: ["openLocation", "getLocation"] // 必填，需要使用的JS接口列表
              });
              wx.ready(function () {
                wx.openLocation({
                  latitude: lat, // 纬度，浮点数，范围为90 ~ -90
                  longitude: lng, // 经度，浮点数，范围为180 ~ -180。
                  name: add, // 位置名
                  address: add, // 地址详情说明
                  scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
                  infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
                });
              });
            });
          }
        } else {
        }
      });
    });
  }
}

/**
 * 密码rsa加密
 * */
export function rsaEncryFn(str) {
 const encryptor = new JSEncrypt(); // 创建加密对象实例
  //之前ssl生成的公钥，复制的时候要小心不要有空格
  encryptor.setPublicKey(pubKey); //设置公钥
  return encryptor.encrypt(str);
}

/**
 *  重写JSEncrypt解密方法以支持公钥解密
 * */
export function pkcs1unpad2(d, n) {
  debugger;
  const b = d.toByteArray();
  let i = 0;
  while (i < b.length && b[i] === 0) {
    ++i;
  }
  // if (b.length - i !== n - 1 || b[i] !== 2) {
  //   return null
  // }
  ++i;
  while (b[i] !== 0) {
    if (++i >= b.length) {
      return null;
    }
  }
  let ret = '';
  while (++i < b.length) {
    const c = b[i] & 255;
    if (c < 128) { // utf-8 decode
      ret += String.fromCharCode(c);
    } else if ((c > 191) && (c < 224)) {
      ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
      ++i;
    } else {
      ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
      i += 2;
    }
  }
  return ret;
}

export function rsaDecryFn(str) {
  debugger;
  if (str) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(pubKey);
    // 不支持公钥解密
    // 自定义解析方法支持公钥解析
    const rsaKey = encrypt.getKey();
    const that = this;
    rsaKey.decrypt = function(ctext) {
      const c = parseBigInt(ctext, 16);
      const m = this.doPublic(c);
      if (m == null) {
        return null;
      }
      return pkcs1unpad2(m, (rsaKey['n'].bitLength() + 7) >> 3);
    };
    rsaKey.decryptLong = function (text) {
      const maxLength = ((rsaKey['n'].bitLength() + 7) >> 3);
      try {
        if (text.length > maxLength) {
          let ct = '';
          const lt = text.match(/.{1,256}/g);
          lt.forEach((entry) => {
            const t1 = rsaKey.decrypt(entry);
            ct += t1;
          });
          return ct;
        }
        const y = rsaKey.decrypt(text);
        return y;
      } catch (ex) {
        return false;
      }
    };
    try {
      return encrypt.getKey()['decryptLong'](b64tohex(str));
    } catch (ex) {
      return false;
    }
  }
  return str;
}




// WEBPACK FOOTER //
// ./src/utils/commons.js